define(
  ["underscore", "360/360", "ext/mindbreeze.theme-module"],
  function(_, Degree360, {ThemeModuleExtensionLoader})
{

  // TODO try to load the extensions by key
  //      this might imply that we need to perform the initializaiton async

  // the hard coded handling of 360Module is wrong here.

  function Mindbreeze360ExtensionModule() {
  }

  _.extend(Mindbreeze360ExtensionModule.prototype, {
    load: function(application, config) {
    },
    unload: function(application, config) {
    }
  });

  // TODO Extensible
  const extensionModuleMap = {
    // "mindbreeze.ai-assistant": new AIAssistantExtensionLoader(),
    "mindbreeze.theme-module": new ThemeModuleExtensionLoader(),
    "mindbreeze.360": new Mindbreeze360ExtensionModule()
  };
  
  function loadExtensions(application, extensionConfigs) {
    return _.map(_.filter(Object.keys(extensionConfigs), function(extensionKey) {
      return extensionModuleMap[extensionKey] != null;
    }), function (extensionKey) {
      return  extensionModuleMap[extensionKey].load(application, extensionConfigs[extensionKey]);
    });
  }

  
  function ExtensionManager(application, options) {
    var options = options || {};
    if (options.parent) {
      // copy all properties form parent, but patch application.
      Object.assign(this, options.parent);
      this.parentManager = options.parent;
    }
    else {
      this.extensionsConfig = options.extensionsConfig || {};
      this.extensions = loadExtensions(application, this.extensionsConfig);
    }
    this.application = application;
    this._360 = null;
    this.application.listenTo(this.application, "initialize360", this.initialize360.bind(this));
  }


    
  ExtensionManager.initializeApplication = function(applicationInstance, options) {
  }

  ExtensionManager.registerExtensionLoader = function(name, loader) {
    extensionModuleMap[name] = loader;
  }
  
  _.extend(ExtensionManager.prototype, {

    clone: function(application) {
        
    },
      
    initialize360: function() {
      var m360Options = {
        application: this.application,
        config: this.application.options.extensions["mindbreeze.360"]
      };
      this.set360Module(m360Options);
    },

    loadClientComponentAsync: function(name, parentLoader) {
      // chain the promises sequentially.
      return _.reduce(this.extensions, function(loadedComponentPromise, extension) {
        return extension ? extension.loadClientComponentAsync(name, loadedComponentPromise) : loadedComponentPromise;
      }, parentLoader);
    },

    // @returns Promise<AppFragmentJson[]>[]
    preloadAppFragments: function(options) {
      var extensionPromises = _.filter(this.extensions, function(extension) {
        return extension && _.isFunction(extension.preloadAppFragments)
      }).map(function(extension) {
        return extension.preloadAppFragments(options.application)
      });
      return extensionPromises;
    },


    getApplicationLaunchHandler: function() {
      // TOOD: multiple extensions and application launching
      //       launching itself is in the core but notifying the launch is
      //       in the extensions.
      var extensionsWithHandlers = _.filter(this.extensions, function (extension) {
        return extension && extension.applicationLaunchHandler });
      if (extensionsWithHandlers.length > 0 ) {
        return extensionsWithHandlers[0].applicationLaunchHandler;
      }

      return null;      
    },

    
    // TODO provide a shell like intereface.
    launchApplication: function(application, launchAppOptions) {
      var extensionLaunchApp = _.filter(this.extensions, function(extension) {
        return extension && _.isFunction(extension.launchApplication)
      }).map(function(extension) {});
      
    },
    
    dispose: function() {
      if (!this.parentManager) {
        _.each(this.extensions, function(extension) {
          extension && extension.unload();
        });
      }
    },
    
    get360Module: function() {
      return this._360;
    },

    set360Module: function(options) {
      if (!options || !options.application || !options.config) {
        this._360 = null;
        console.warn("Could not set 360 module!");
        return;
      }

      this._360 = new Degree360(options);
      this._360.initialize();
    },

    remove360Module: function() {
      this._360 = null;
    },

    updateExtensionOptions: function(optionsString) {
      // case one: not in desginer
      if (!optionsString && (!this.application.editing || this.extensionsConfig["mindbreeze.360"])) {
        // TODO: check effective config -> reload
        return;
      }
      // case two: in desginer
      if (!optionsString && this.application.editing && !this._360) {
        this.application.trigger("remove360");
        this.application.models &&
          this.application.models.search &&
          this.application.models.search.set("name", "default", {
            silent: true
          });
        return;
      }
      try {
        var optionsJSON = JSON.parse(optionsString);
        this.application.options.extensions = _.extend(this.application.options.extensions || {}, optionsJSON);
        var extensionsKeys = Object.keys(this.application.options.extensions);
        for (var keyIndex = 0; keyIndex < extensionsKeys.length; keyIndex++) {
          var key = extensionsKeys[keyIndex];
          if (key === "mindbreeze.360") {
            this.application.trigger("remove360");
            this.application.execute(function(app) {
              var m360Options = {
                application: app,
                config: app.options.extensions["mindbreeze.360"]
              };
              app.getExtensionManager().set360Module(m360Options);
              // The apps created and stored with mmc insight app designer 
              // need to re-trigger search if opend with query in url
              app.models &&
                app.models.search &&
                app.models.search.set("name", "360", {
                  silent: false
                });
            });
          } else {
            //here belong the logic to initalize the extension modules
          }
        }
      } catch (e) {
        // it make sence specially in designer context to avoid using old settings
        if (this.application) {
          this.application.trigger("remove360");
          this.application.models &&
            this.application.models.search &&
            this.application.models.search.set("name", "default", {
              silent: true
            });
        }
      }
    }
  });

  return ExtensionManager;
});
